"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Loading = void 0;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _EmptyBanner = require("../../Banners/EmptyBanner");

var _ErrorBanner = require("../../Banners/ErrorBanner");

var _LoadingBanner = require("../../Banners/LoadingBanner");

var _ILoading = require("../../models/ILoading");

var Loading = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Loading, _React$Component);

  var _super = (0, _createSuper2.default)(Loading);

  function Loading() {
    (0, _classCallCheck2.default)(this, Loading);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Loading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isLoading = _this$props.isLoading,
          children = _this$props.children,
          loadingState = _this$props.loadingState,
          loadingError = _this$props.loadingError,
          value = _this$props.value,
          loadingText = _this$props.loadingText,
          loadingErrorAction = _this$props.loadingErrorAction,
          loadingActionText = _this$props.loadingActionText;
      var localizedError = loadingError;

      if (loadingState === _ILoading.LoadingState.error) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBanner.ErrorBanner, {
          text: localizedError ? localizedError.localizedMessage : undefined,
          onAction: loadingErrorAction,
          actionText: loadingActionText
        });
      } else if (isLoading) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingBanner.LoadingBanner, {
          text: loadingText
        });
      } else if ((0, _isArray.default)(value) && value.length === 0) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyBanner.EmptyBanner, {});
      }

      return children;
    }
  }]);
  return Loading;
}(React.Component);

exports.Loading = Loading;